import { Injectable } from '@angular/core';
import { NbMenuItem } from '@nebular/theme';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';

@Injectable({
  providedIn: 'root'
})
export class EditorService {
  private
  menuGroups: any;
  topLevelMenu: MenuGroup;
  secondaryMenus: MenuGroup[] = [];
  tertiaryMenus: MenuGroup[] = [];

  private dialogCloseSubject = new Subject<any>();
  public dialogClose$ = this.dialogCloseSubject.asObservable();
  private inputComponent: Subject<DynamicInputComponent> = new BehaviorSubject<DynamicInputComponent>(null);

  getInputComponent(): Observable<DynamicInputComponent> {
    return this.inputComponent.asObservable()
  }

  setInputComponent(data: DynamicInputComponent) {
    this.inputComponent.next(data);
  }

  constructor() { }

  createMenusFromGroup(menuGroup: MenuGroup): any {
    this.topLevelMenu = {
      title: menuGroup.title,
      menuTag: menuGroup.menuTag,
      menuItems: this.getSecondaryMenuItems(menuGroup.menuItems)
    }
    // console.log(this.topLevelMenu)
    // console.log(this.secondaryMenus)
    // console.log(this.tertiaryMenus);
    this.menuGroups = {
      topLevelMenu: this.topLevelMenu,
      secondaryMenus: this.secondaryMenus,
      tertiaryMenus: this.tertiaryMenus
    }
    return this.menuGroups
  }

  createSecondaryMenu(menuItem: NbMenuItem) {
    const menuItems: NbMenuItem[] = [];
    menuItem.children.forEach(childMenuItem => {
      if (childMenuItem.children == undefined && childMenuItem.children == null) {
        menuItems.push(childMenuItem);
      } else {
        this.createTertiaryMenu(childMenuItem);
        const { children, ...rest } = childMenuItem;
        menuItems.push(rest);
      }
    })
    const secondaryMenu: MenuGroup = {
      title: menuItem.title,
      menuItems: menuItems,
      menuTag: this.toCamelCase(menuItem.title)
    }
    this.secondaryMenus.push(secondaryMenu);
  }

  createTertiaryMenu(menuItem: NbMenuItem) {
    const _menuItems: NbMenuItem[] = [];
    menuItem.children.forEach(childMenuItem => {
      _menuItems.push(childMenuItem);
    })
    const tertiaryMenu: MenuGroup = {
      title: menuItem.title,
      menuItems: _menuItems,
      menuTag: this.toCamelCase(menuItem.title)
    }
    this.tertiaryMenus.push(tertiaryMenu);
  }

  toCamelCase(sentenceCase) {
    let out = "";
    sentenceCase.split(" ").forEach(function (el, idx) {
      const add = el.toLowerCase();
      out += (idx === 0 ? add : add[0].toUpperCase() + add.slice(1));
    });
    return out;
  }

  getSecondaryMenuItems(menuItems: NbMenuItem[]) {
    const _menuItems: NbMenuItem[] = [];
    menuItems.forEach(menuItem => {
      if (menuItem.children == undefined || menuItem.children == null) {
        _menuItems.push(menuItem);
      } else {
        this.createSecondaryMenu(menuItem);
        const { children, ...rest } = menuItem;
        _menuItems.push(rest);
      }
    })
    return _menuItems;
  }

  notifyDialogClose(data?: any) {
    this.dialogCloseSubject.next(data);
  }


}

